export function getUrlParam(name) {
    let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
    let r = window.location.search.substring(1).match(reg);
    let strValue = "";
    if (r != null) {
        strValue = decodeURI(r[2]);
    }
    return strValue;
}